import React, {useContext, useState} from 'react';
import OrgPage from "../../../../components/OrgPage";
import {VerificationCenter_API} from "../../VerificationCenterAPI";
import {useParams} from "react-router-dom";
import TextCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import EditPatientModal from "../../../../components/Organisms/EditPatientModal";
import moment from "moment";
import StatusCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/StautsCell/StatusCell";
import {AuthContext} from "../../../../context/AuthContext";
import {formatDate} from "../../../../utils/utils";

function OrganizationCabinetSurveyHistory() {
    const {orgId, orgName} = useParams()
    // const {getAllOrganizationCabinetSurveys, updateCabinetSurveyPatient} = VerificationCenter_API.errors.cabinetSurvey
	const {getOrganizationCarSurveys, updateSurveyPatient} = VerificationCenter_API.errors.carSurvey
    const baseUrl = process.env.REACT_APP_BASE_URL
    const [modal, setModal] = useState({hide: true, API: {}, initialForm: {}})
    const [refresh, setRefresh] = useState(false)
	const {token} = useContext(AuthContext)

	const editPatient = (errorId, initialForm) => {
        setModal({
            hide: false,
            API: VerificationCenter_API.allPatients.updatePatient(token.userId, orgId, errorId),
            initialForm
        })
    }

    const modalCloseHandler = () => {
        setModal({hide: true})
        setRefresh(!refresh)
    }

    const errorNameCell = props => {
        const initialChangeForm = {
            fio: props.all?.fio,
            dob: moment(props.all.dob,).format('YYYY-MM-DD'),
            jobName: props.all.job_name
        }
        return <LinkCell3 linkTitle={props.all?.fio}
                          editClick={_ => {if (props.all?.id>0) {editPatient(props.all?.id, initialChangeForm)}}}/>
    }

    const statusCell = (props) => {
        const statusSwitcher = (status) => {
            if (status === "Не прошел") {
                return 'orange'
            }
            if (status === 'Прошел') {
                return 'green'
            }
            if (status === 'Ошибка') {
                return 'red'
            }
        }
        return <StatusCell text={props.all?.status} color={statusSwitcher(props.all?.status)}/>
    }

    const patientDobCell = props => <TextCell text={formatDate(props.all.dob)}/>
    const orgNameCell = props => <TextCell text={props.all?.job_name}/>


    return (
        <>
            <OrgPage
                refresh={refresh}
                url={baseUrl + getOrganizationCarSurveys(token.userId, orgId).api}

                                firstRow={[{
                    title: 'ФИО',
                    id: 'fio'
                }, {title: 'Дата рождения'}, {title: 'Место работы'}, {title: 'Дата прохождения'}, {title: 'Дата прохождения'},]}
                haveToShow={[
                    {
                        id: 'fio',
                        idArr: ['id', ''],
                        type: 'wrapperCell',
                        typeData: {cell: errorNameCell}
                    },
                    {id: 'patient_info', type: 'wrapperCell', typeData: {cell: patientDobCell}},
                    {id: 'org_info', type: 'wrapperCell', typeData: {cell: orgNameCell}},
                    {
                        id: 'result_date',
                        type: "wrapperCell",
                        typeData: {
                            cell: props => <TextCell
                                text={props.all.result_date ? formatDate(props.all.result_date) : ""}/>
                        }
                    },
                    {id: 'status', type: 'wrapperCell', typeData: {cell: statusCell}},
                ]}
                exportTemplateButtons={{
                    export: true, registry: true,
                    exportUrl: `/api/v2/general/export/excel?historyId=${orgId}?`,
                    registryUrl: `/api/v2/general/export/registry?historyId=${orgId}?`
                }}
                filterFieldsConf={{
                    fio: true,
                    status: true
                }}
                breadCrumbsItems={[
                    {title: 'Каленадрь'},
					{ title: 'История обследований', link: process.env.REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys' },
                    {title: orgName, actual: true}
                ]}
                filterBarButtons={{
                    downloadTemplate: {show: false}
                }}

            />
            {
                modal.hide
                    ? ""
                    :
                    <EditPatientModal initialForm={modal.initialForm} API={modal.API} closeHandler={modalCloseHandler}/>
            }

        </>


    );
}


export default OrganizationCabinetSurveyHistory;


